import * as React from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
//import { ReactQueryConfigProvider } from "react-query";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import oktaConfig from "../oktaConfig";
import { AuthProvider } from "./auth-context";
import { ContentProvider } from "./content-context";
import { MediaContextProvider } from "./media-context";
import { GAProvider } from "./ga-context";
import { QueryClientProvider } from "./query-client";
import AuthRequiredModal from "../screens/components/elements/AuthRequiredModal";

const oktaAuth = new OktaAuth(oktaConfig.oidc);

const WithCustomOauthHandler = ({ children }) => {
  const [showAuthRequired, setshowAuthRequired] = React.useState(false);

  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  const redirectLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const customAuthHandler = async () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      //await redirectLogin();
      setshowAuthRequired(true);
    }
  };

  // const customAuthHandler = () => {
  //   history.push("/login");
  // };
  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}
    >
      <AuthRequiredModal
        {...{ showAuthRequired, setshowAuthRequired, redirectLogin }}
      />

      {children}
    </Security>
  );
};

function AppProviders({ children }) {
  return (
    <QueryClientProvider>
      <Router>
        <WithCustomOauthHandler>
          <AuthProvider>
            <MediaContextProvider>
              <GAProvider>
                <ContentProvider>{children}</ContentProvider>
              </GAProvider>
            </MediaContextProvider>
          </AuthProvider>
        </WithCustomOauthHandler>
      </Router>
    </QueryClientProvider>
  );
}

export { AppProviders };
